<template>
  <Modal name="editNotes">
    <ModalCard>
      <template v-slot:title>Edit Notes</template>
      
      <div class="field">
        <div class="control">
          <textarea class="textarea" rows="10" v-model="notes" />
        </div>
      </div>

      <template v-slot:buttons>
        <div class="button is-primary" @click="saveNotes">
          Save Changes
        </div>
      </template>
      </ModalCard>
  </Modal>
</template>

<script>
import { defineComponent, inject, ref, watch } from 'vue'

import useModal from '@/hooks/useModal'

import Modal from '@/components/Modal'
import ModalCard from '@/components/ModalCard'

export default defineComponent({
  components: {
    Modal,
    ModalCard
  },

  setup (props, { emit }) {
    const character = inject('character')
    const { currentModal } = useModal()

    const notes = ref(null)
    watch(currentModal, (modal) => {
      if (!modal || modal.name !== 'editNotes') return
      notes.value = character.notes
    })

    const saveNotes = () => {
      emit('notesUpdated', notes.value.trim())
    }

    return {
      notes,
      saveNotes
    }
  },
})
</script>
